import { createContext, useContext } from "react";
const TableContext = createContext(null);
function useTableContext() {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error("Table compound components cannot be rendered outside the Table component");
  }
  return context;
}
export {
  TableContext,
  useTableContext
};
//# sourceMappingURL=context7.js.map
